import React from 'react';
import ReactDOM from 'react-dom';
import { Segment } from 'semantic-ui-react';
import {
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
  List,
} from 'react-virtualized';
import { Message } from './components';
import styles from './Messages.css';

class Messages extends React.Component {
  constructor(props) {
    super(props);
    this._rowRenderer = this._rowRenderer.bind(this);
    this._handleResize = this._handleResize.bind(this);
    this._cache = new CellMeasurerCache({
      fixedWidth: true,
      minHeight: 30,
    });

    this.state = {
      dimensions: {
        width: -1,
        height: -1,
        top: -1,
        bottom: -1,
      },
      scrollToIndex: 0,
    };
  }

  get _rowCount() {
    return this._lastIndex + 1;
  }
  get _lastIndex() {
    return this.lastIndex(this.props);
  }
  lastIndex(props) {
    const { messages, showTyping } = props;
    if (showTyping) {
      return messages.length;
    }
    return messages.length - 1;
  }

  componentWillReceiveProps(nextProps) {
    const { messages } = nextProps;
    if (messages.length > 0 && this.props.messages.length === 0) {
      this.setState({
        scrollToIndex: this.lastIndex(nextProps),
      });
    }
  }
  componentDidUpdate() {
    // const { messages } = this.props;
    const index = this._lastIndex;
    const el = document.getElementById(`list_${index}`);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ block: 'end', behavior: 'smooth' });
      }, 10);
    }
  }
  render() {
    // const { showTyping } = this.props;
    const { height } = this.state.dimensions;
    const scrollToIndex = this.state.scrollToIndex;
    return (
      <Segment
        style={{
          boxShadow: 'none',
          height,
        }}
        raised={false}
      >
        <AutoSizer onResize={this._handleResize}>
          {({ height, width }) => (
            <List
              className={styles.List}
              height={height}
              // overscanRowCount={overscanRowCount}
              rowCount={this._rowCount}
              rowHeight={this._cache.rowHeight}
              // rowHeight={30}
              rowRenderer={this._rowRenderer}
              scrollToIndex={scrollToIndex}
              width={width}
            />
          )}
        </AutoSizer>
      </Segment>
    );
  }
  _handleResize(size) {
    const rect = ReactDOM.findDOMNode(this).getBoundingClientRect();
    const height = window.innerHeight - rect.y - 112; // TODO: Make this more accurate
    const dimensions = {
      height,
      width: this.state.dimensions.width,
      top: this.state.dimensions.top,
      bottom: this.state.dimensions.bottom,
    };
    this.setState({ dimensions });
  }
  _rowRenderer({
    key, // Unique key within array of rows
    index, // Index of row within collection
    isScrolling, // The List is currently being scrolled
    isVisible, // This row is visible within the List (eg it is not an overscanned row)
    parent,
    style, // Style object to be applied to row (to position it)
  }) {
    // console.log('KEY: ', key, index);
    if (index >= this.props.messages.length) {
      // console.log('Index: ', index, ' Message L ', this.props.messages.length);
      return (
        <div style={style} key={key} id={`list_${index}`}>
          typing indicator
        </div>
      );
    }
    const message = this.props.messages[index];
    // const dom = (
    //   <Message style={style} key={key} id={`list_${index}`} message={message} />
    // );
    return (
      <CellMeasurer
        cache={this._cache}
        key={key}
        rowIndex={index}
        parent={parent}
      >
        <div
          style={{
            padding: '0.3em 0',
            ...style,
            width: this.state.dimensions.width,
          }}
          id={`list_${index}`}
        >
          <Message
            // style={style}
            // key={key}

            message={message}
          />
        </div>
      </CellMeasurer>
      // <div style={style} key={key} id={`list_${index}`}>
      //   {message.text}
      // </div>
    );
    // return (
    //   <div key={key} style={style}>
    //     {data[index].text}
    //   </div>
    // );
  }

  _getDatum(index) {
    const { messages } = this.props;
    return messages.get(index % messages.size);
  }

  _getRowHeight({ index }) {
    return this._getDatum(index).size;
  }
}

export default Messages;



// WEBPACK FOOTER //
// ./src/containers/Chat/components/ChatComponent/components/Messages/index.jsx